import { useQuery } from '@tanstack/react-query';

import { queryClient } from '../components/queryClient';
import { useFleet } from '../hooks/useFleet';
import { FleetService } from '../services';

export const useFleetHealth = (checkPeriod?: number) => {
  const fleet = useFleet();
  const queryKey = ['fleetHealth', fleet.id, checkPeriod ?? 'default'];

  const queryFn = () => FleetService.getHealth(checkPeriod);

  return useQuery({
    queryKey,
    queryFn,
    enabled: !!fleet.id && !!fleet.config.device_health_config?.is_enabled,
  });
};

export const refreshFleetHealth = (fleetId: number, checkPeriod?: number) => {
  const queryKey = ['fleetHealth', fleetId, checkPeriod ?? 'default'];
  queryClient.invalidateQueries({ queryKey });
};
